import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Kuru temizleme ve ütü hizmeti",
  heroDescription: "Adana'da kıyafetleriniz için özenli kuru temizleme ve ütü hizmeti. Day Temizlik Adana ile pratik ve güvenilir çözüm.",
  description: "Kıyafetlerin düzenli, temiz ve bakımlı görünmesi günlük yaşamda önemlidir. Day Temizlik Adana, kuru temizleme ve ütü hizmetinde kıyafetlerinize özen gösteren, düzenli ve pratik çözümler sunar. Özenli paketleme ve düzenli teslim süreciyle güvenilir hizmet anlayışıyla çalışıyoruz.",
  scope: [
    "Kıyafet temizliği",
    "Ütü hizmeti",
    "Özenli paketleme alanı",
    "Günlük ve özel kıyafetlere uygun yaklaşım",
    "Düzenli teslim süreci",
  ],
  forWho: [
    "Ev sahipleri",
    "İş profesyonelleri",
    "Ofis çalışanları",
    "Özel davet ve organizasyon katılımcıları",
    "Kuru temizleme ihtiyacı olan herkes",
  ],
  process: [
    "Kıyafetlerin yapısı ve temizlik ihtiyacını değerlendiriyoruz.",
    "Kumaş tipine uygun temizlik yöntemini belirliyoruz.",
    "Kuru temizleme veya ütü işlemini uyguluyoruz.",
    "Özenli kontrol ve paketleme yapıyoruz.",
    "Belirlenen sürede teslim ediyoruz.",
  ],
  whyProfessional: [
    "Kumaş yapısına uygun temizlik sayesinde kıyafetler korunur.",
    "Profesyonel ütü ile daha düzgün ve bakımlı görünüm sağlanır.",
    "Özenli paketleme sayesinde kıyafetler zarar görmez.",
    "Düzenli teslim süreci planlarınızı aksatmaz.",
    "Günlük ve özel kıyafetleriniz için güvenilir çözüm sunulur.",
  ],
  relatedServices: [
    { title: "Halı Yıkama", path: "/hizmetlerimiz/hali-yikama" },
    { title: "Koltuk Yıkama", path: "/hizmetlerimiz/koltuk-yikama" },
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
  ],
  faqs: [
    { question: "Kuru temizleme hizmeti ne kadar sürer?", answer: "Kıyafet sayısına ve işlem yoğunluğuna göre değişir. Genellikle 1-3 gün içinde teslim edilir." },
    { question: "Hangi kıyafetler kuru temizleme yapılır?", answer: "İpek, yün, keten ve hassas kumaşlı kıyafetler ile özel giyim ürünleri kuru temizleme yapılır." },
    { question: "Ütü hizmeti ayrı alınabilir mi?", answer: "Evet, ütü hizmeti ayrı olarak da talep edilebilir." },
  ],
  ctaText: "Kıyafetleriniz için özenli temizlik ve ütü hizmeti alın.",
  heroImage: "/assets/images/kuru-temizleme-utu.jpg",
};

export default function KuruTemizlemePage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}